var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:_vm.$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-5'},[_c('IbCommissionInTabTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }